import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import Footer from './components/Footer';
import { categories, faqData } from '@/mocks/categories';
import { seoArticles } from '@/mocks/seoArticles';
import { SITE_URL } from '@/constants';

const benefits = [
  {
    icon: 'ri-timer-flash-line',
    title: 'Risparmio di tempo',
    desc: 'Trova prodotti gi&agrave; organizzati senza effettuare centinaia di ricerche manuali. Ogni categoria &egrave; curata e aggiornata per offrirti solo il meglio.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Migliore confronto',
    desc: 'Confronta prezzi, qualit&agrave;, recensioni e caratteristiche dei prodotti in un unico posto. Prendi decisioni informate senza saltare da un sito all\'altro.',
  },
  {
    icon: 'ri-shield-user-line',
    title: 'Maggiore sicurezza',
    desc: 'Segui consigli verificati e controlli approfonditi prima di ogni acquisto. La tua sicurezza &egrave; la nostra priorit&agrave; con venditori affidabili e metodi testati.',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Ricerca intelligente',
    desc: 'Accedi alle categorie pi&ugrave; richieste e scopri prodotti di tendenza selezionati dal nostro team di esperti italiani per il mercato del 2026.',
  },
];

const steps = [
  { num: '01', title: 'Scegli categoria prodotto', desc: 'Naviga tra le 14 categorie disponibili e trova esattamente ci&ograve; che ti interessa.' },
  { num: '02', title: 'Analizza informazioni', desc: 'Consulta prezzi, recensioni e foto reali dei prodotti selezionati per te.' },
  { num: '03', title: 'Confronta alternative', desc: 'Metti a confronto prodotti simili e scegli l\'opzione migliore per le tue esigenze.' },
  { num: '04', title: 'Acquista sulla piattaforma', desc: 'Completa l\'acquisto in sicurezza tramite la piattaforma principale con pagamenti protetti.' },
];

const securityRows = [
  { element: 'Qualit&agrave; prodotto', check: 'Foto reali e recensioni verificate' },
  { element: 'Venditore', check: 'Analisi affidabilit&agrave; e storico' },
  { element: 'Prezzo', check: 'Confronto mercato e storico prezzi' },
  { element: 'Pagamento', check: 'Sistemi protetti e crittografati' },
  { element: 'Privacy', check: 'Protezione dati e anonimato' },
];

const topCategories = [
  { name: 'Scarpe', icon: 'ri-footprint-line', url: 'https://kaspreadsheet.com/category-911-Shoes.html', image: 'https://readdy.ai/api/search-image?query=Single%20pair%20of%20premium%20cream%20white%20minimalist%20sneakers%20on%20light%20beige%20textured%20surface%2C%20soft%20natural%20daylight%20from%20left%2C%20clean%20product%20photography%20style%2C%20warm%20neutral%20tones%2C%20elegant%20isolated%20composition%2C%20high%20detail%20stitching%20visible%2C%20simple%20sophisticated%20aesthetic&width=400&height=300&seq=topcat-shoes&orientation=landscape' },
  { name: 'Felpe', icon: 'ri-shirt-line', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20cream%20knit%20sweater%20neatly%20folded%20on%20light%20linen%20fabric%2C%20soft%20morning%20sunlight%20casting%20gentle%20shadows%2C%20minimal%20scandinavian%20product%20photography%2C%20warm%20beige%20and%20ivory%20tones%2C%20clean%20composition%2C%20high%20detail%20fabric%20texture%20visible%2C%20calm%20aesthetic&width=400&height=300&seq=topcat-hoodies&orientation=landscape' },
  { name: 'T-Shirt', icon: 'ri-t-shirt-line', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20white%20tshirt%20laid%20flat%20on%20natural%20linen%20background%2C%20soft%20diffused%20daylight%2C%20clean%20minimal%20product%20photography%2C%20warm%20neutral%20cream%20tones%2C%20elegant%20simple%20composition%2C%20high%20detail%20fabric%20texture%2C%20sophisticated%20casual%20style&width=400&height=300&seq=topcat-tshirts&orientation=landscape' },
  { name: 'Giacche', icon: 'ri-sun-line', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=Stylish%20lightweight%20beige%20bomber%20jacket%20hanging%20on%20minimalist%20wooden%20hanger%20against%20soft%20cream%20wall%2C%20natural%20window%20light%2C%20editorial%20fashion%20photography%2C%20warm%20neutral%20tones%2C%20clean%20sophisticated%20composition%2C%20high%20detail%20fabric%20texture&width=400&height=300&seq=topcat-jackets&orientation=landscape' },
  { name: 'Accessori', icon: 'ri-glasses-line', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20minimalist%20watch%20leather%20wallet%20and%20sunglasses%20on%20light%20marble%20surface%2C%20soft%20natural%20light%2C%20lifestyle%20editorial%20photography%2C%20warm%20beige%20and%20cream%20tones%2C%20sophisticated%20clean%20composition%2C%20high%20detail%20craftsmanship%20visible&width=400&height=300&seq=topcat-accessories&orientation=landscape' },
  { name: 'Borse', icon: 'ri-handbag-line', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', image: 'https://readdy.ai/api/search-image?query=Premium%20leather%20tote%20bag%20in%20warm%20cognac%20tone%20placed%20on%20light%20oak%20wooden%20surface%2C%20soft%20window%20light%2C%20minimal%20product%20photography%2C%20warm%20earthy%20neutral%20palette%2C%20elegant%20simple%20composition%2C%20high%20detail%20leather%20texture%2C%20sophisticated%20aesthetic&width=400&height=300&seq=topcat-bags&orientation=landscape' },
];

export default function Home() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Itaobuy Spreadsheet Italia',
    url: SITE_URL,
    description: 'La guida italiana per trovare i migliori prodotti online',
    logo: `${SITE_URL}/favicon.jpeg`,
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Itaobuy Spreadsheet Italia 2026 | Guida, Liste Prodotti e Acquisti Sicuri',
    description: 'Scopri Itaobuy Spreadsheet: la guida italiana completa per trovare prodotti, confrontare prezzi, analizzare qualità e acquistare in modo più semplice e sicuro.',
    url: `${SITE_URL}/`,
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <Navbar />
      <main>
        <HeroSection />

        {/* What is Itaobuy Spreadsheet */}
        <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
          <div className="max-w-[1400px] mx-auto">
            <div className="flex flex-col lg:flex-row items-center gap-14 lg:gap-20">
              <div className="flex-1 lg:max-w-[45%]">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
                  Italia 2026
                </span>
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-6 leading-tight">
                  Cos&apos;&egrave;
                  <br />
                  <span className="text-primary-600">Itaobuy Spreadsheet?</span>
                </h2>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  Itaobuy Spreadsheet &egrave; uno <strong>strumento organizzato</strong> che permette agli utenti italiani di raccogliere, analizzare e confrontare prodotti provenienti da marketplace internazionali. Nato dall&apos;esigenza di semplificare lo shopping online, questo sistema offre un&apos;esperienza di ricerca fluida e intuitiva.
                </p>
                <p className="text-foreground-600 leading-relaxed mb-6">
                  Grazie a <strong>categorie ordinate</strong>, informazioni dettagliate e sistemi di confronto avanzati, gli utenti possono trovare rapidamente prodotti interessanti evitando ricerche lunghe e complicate. Che tu stia cercando scarpe, abbigliamento streetwear o accessori, Itaobuy Spreadsheet ti guida passo dopo passo.
                </p>
                <Link
                  to="/articolo/guida-completa-itaobuy-spreadsheet"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  Leggi la guida completa
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </Link>
              </div>
              <div className="flex-1 lg:max-w-[55%] w-full">
                <div className="relative rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20curated%20fashion%20pieces%20including%20folded%20garments%20accessories%20and%20lifestyle%20items%20on%20warm%20ivory%20textured%20paper%20background%2C%20soft%20diffused%20natural%20daylight%2C%20editorial%20catalog%20aesthetic%2C%20neutral%20cream%20beige%20and%20sand%20tones%2C%20clean%20modern%20composition%20with%20organic%20spacing%2C%20sophisticated%20product%20display%2C%20high%20detail%20texture&width=1200&height=800&seq=about-display-v2&orientation=landscape"
                    alt="Itaobuy Spreadsheet prodotti organizzati"
                    className="w-full h-auto"
                    title="Itaobuy Spreadsheet organizzazione prodotti"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/40 to-transparent p-6">
                    <span className="text-xs font-medium text-background-50 bg-background-50/20 backdrop-blur-sm px-3 py-1 rounded-full whitespace-nowrap">
                      14+ Categorie · 1000+ Prodotti
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-4">
                Perch&eacute; utilizzare
                <br />
                <span className="text-primary-600">Itaobuy Spreadsheet?</span>
              </h2>
              <p className="text-foreground-500 max-w-[600px] mx-auto">
                Scopri i vantaggi che rendono Itaobuy Spreadsheet lo strumento preferito dagli acquirenti italiani.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {benefits.map((b) => (
                <div
                  key={b.title}
                  className="group bg-background-50 rounded-2xl p-6 md:p-8 hover:bg-background-50 transition-all duration-300 border border-background-200/60"
                >
                  <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className={`${b.icon} text-lg`}></i>
                  </span>
                  <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                    {b.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {b.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Categories with Images Section */}
        <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-4">
                Esplora le <span className="text-primary-600">Categorie</span>
              </h2>
              <p className="text-foreground-500 max-w-[600px] mx-auto">
                Ogni categoria ha un&apos;immagine dedicata per aiutarti a trovare subito ci&ograve; che cerchi.
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
              {categories.map((cat) => (
                <a
                  key={cat.nameEn}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="group flex flex-col rounded-2xl bg-background-100 border border-background-200/60 hover:border-primary-300 overflow-hidden transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-28 overflow-hidden">
                    <img
                      src={cat.image}
                      alt={`Itaobuy Spreadsheet ${cat.name}`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={`Itaobuy Spreadsheet categoria ${cat.name}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                    <span className="absolute top-2 left-2 w-6 h-6 flex items-center justify-center rounded-md bg-background-50/80 backdrop-blur-sm text-primary-600">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                  </div>
                  <div className="px-3 py-3">
                    <span className="text-xs font-semibold text-foreground-700 group-hover:text-foreground-900 text-center block whitespace-nowrap transition-colors">
                      {cat.name}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-4">
                Come funziona{' '}
                <span className="text-primary-600">Itaobuy Spreadsheet?</span>
              </h2>
              <p className="text-foreground-500 max-w-[600px] mx-auto">
                In quattro semplici passaggi, dal prodotto desiderato all&apos;acquisto sicuro.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {steps.map((step, i) => (
                <div key={step.num} className="relative">
                  <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/60 h-full">
                    <span className="text-5xl font-heading font-extrabold text-primary-200 mb-4 block">
                      {step.num}
                    </span>
                    <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                      {step.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {step.desc}
                    </p>
                  </div>
                  {i < steps.length - 1 && (
                    <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                      <span className="w-6 h-6 flex items-center justify-center text-primary-400">
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Security Section */}
        <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
          <div className="max-w-[1400px] mx-auto">
            <div className="flex flex-col lg:flex-row items-center gap-14 lg:gap-20">
              <div className="flex-1 lg:max-w-[50%]">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4 whitespace-nowrap">
                  Sicurezza
                </span>
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-6 leading-tight">
                  Itaobuy Spreadsheet
                  <br />
                  <span className="text-primary-600">&egrave; sicuro?</span>
                </h2>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  La sicurezza &egrave; una delle nostre priorit&agrave; assolute. Itaobuy Spreadsheet &egrave; stato progettato per offrirti un&apos;esperienza di acquisto <strong>completamente protetta</strong> in ogni fase del processo.
                </p>
                <p className="text-foreground-600 leading-relaxed">
                  Dalla verifica dei venditori alla protezione dei tuoi dati personali, ogni elemento &egrave; attentamente controllato per garantirti la massima tranquillit&agrave; durante i tuoi acquisti online.
                </p>
              </div>
              <div className="flex-1 lg:max-w-[50%] w-full">
                <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
                  <table className="w-full">
                    <thead>
                      <tr className="border-b border-background-200/60">
                        <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700 whitespace-nowrap">Elemento</th>
                        <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700 whitespace-nowrap">Controllo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {securityRows.map((row) => (
                        <tr key={row.element} className="border-b border-background-200/40 last:border-0">
                          <td className="px-6 py-4 text-sm font-medium text-foreground-800 whitespace-nowrap">{row.element}</td>
                          <td className="px-6 py-4 text-sm text-foreground-500">
                            <span className="flex items-center gap-2">
                              <span className="w-4 h-4 flex items-center justify-center text-primary-500">
                                <i className="ri-check-line"></i>
                              </span>
                              {row.check}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Top Categories with Images */}
        <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-4">
                Categorie pi&ugrave; <span className="text-primary-600">popolari</span>
              </h2>
              <p className="text-foreground-500 max-w-[600px] mx-auto">
                Le categorie pi&ugrave; amate dalla community italiana di acquirenti online.
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {topCategories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="group relative bg-background-50 rounded-2xl border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer overflow-hidden"
                >
                  <div className="h-36 overflow-hidden">
                    <img
                      src={cat.image}
                      alt={`Itaobuy Spreadsheet ${cat.name}`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={`Itaobuy Spreadsheet ${cat.name}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                  </div>
                  <div className="px-4 py-4 relative z-10 flex flex-col items-center gap-2">
                    <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                      <i className={`${cat.icon} text-base`}></i>
                    </span>
                    <span className="text-sm font-semibold text-foreground-800 group-hover:text-foreground-900 whitespace-nowrap transition-colors">
                      {cat.name}
                    </span>
                  </div>
                </a>
              ))}
            </div>

            <div className="text-center mt-10">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                Esplora tutte le categorie
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            </div>
          </div>
        </section>

        {/* Comparison Section */}
        <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-4">
                Itaobuy Spreadsheet vs{' '}
                <span className="text-primary-600">ricerca tradizionale</span>
              </h2>
              <p className="text-foreground-500 max-w-[600px] mx-auto">
                Ecco perch&eacute; Itaobuy Spreadsheet &egrave; la scelta migliore per i tuoi acquisti.
              </p>
            </div>

            <div className="max-w-[800px] mx-auto">
              <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
                <table className="w-full">
                  <thead>
                    <tr className="border-b border-background-200/60">
                      <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700 whitespace-nowrap">Metodo</th>
                      <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700 whitespace-nowrap">Tempo</th>
                      <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700 whitespace-nowrap">Precisione</th>
                      <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700 whitespace-nowrap">Risparmio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-background-200/40">
                      <td className="px-6 py-4 text-sm font-medium text-foreground-800 whitespace-nowrap">Ricerca manuale</td>
                      <td className="px-6 py-4 text-sm text-accent-600 font-medium whitespace-nowrap">Alto</td>
                      <td className="px-6 py-4 text-sm text-accent-600 font-medium whitespace-nowrap">Media</td>
                      <td className="px-6 py-4 text-sm text-accent-600 font-medium whitespace-nowrap">Basso</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm font-semibold text-primary-700 whitespace-nowrap">Itaobuy Spreadsheet</td>
                      <td className="px-6 py-4 text-sm font-semibold text-primary-600 whitespace-nowrap">Basso</td>
                      <td className="px-6 py-4 text-sm font-semibold text-primary-600 whitespace-nowrap">Alta</td>
                      <td className="px-6 py-4 text-sm font-semibold text-primary-600 whitespace-nowrap">Alto</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>

        {/* 9 SEO Articles Grid */}
        <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-16">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4 whitespace-nowrap">
                Guide SEO
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-4">
                Articoli <span className="text-primary-600">Itaobuy Spreadsheet</span>
              </h2>
              <p className="text-foreground-500 max-w-[650px] mx-auto">
                Approfondisci ogni aspetto di Itaobuy Spreadsheet con la nostra raccolta di guide SEO complete e aggiornate per il 2026.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {seoArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/articolo/${article.slug}`}
                  onClick={() => window.scrollTo(0, 0)}
                  className="group bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.h1}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={article.h1}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                    <span className="absolute bottom-3 left-3 px-2.5 py-1 rounded-full bg-background-50/80 backdrop-blur-sm text-xs font-medium text-foreground-700 whitespace-nowrap">
                      {article.date}
                    </span>
                  </div>
                  <div className="p-5">
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                      {article.h1}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="mt-4 flex items-center gap-1.5 text-xs font-medium text-primary-600 whitespace-nowrap">
                      Leggi l'articolo
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            <div className="text-center mt-12">
              <Link
                to="/guida-shopping"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                Vedi tutte le Guide
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-24 md:py-32 px-6 md:px-10 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Luxurious%20lifestyle%20composition%20with%20elegant%20accessories%20premium%20leather%20goods%20and%20delicate%20jewelry%20on%20soft%20cream%20silk%20fabric%2C%20warm%20golden%20hour%20light%20streaming%20through%20sheer%20curtains%2C%20sophisticated%20editorial%20photography%2C%20warm%20ivory%20and%20champagne%20tones%2C%20refined%20elegant%20atmosphere%2C%20high%20end%20product%20display%2C%20soft%20dreamy%20bokeh%20background&width=1800&height=800&seq=cta-section-v2&orientation=landscape"
              alt="Itaobuy Spreadsheet shopping"
              className="w-full h-full object-cover"
              title="Itaobuy Spreadsheet esperienza di acquisto"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-background-50/90 via-background-50/60 to-background-50/90"></div>

          <div className="relative z-10 max-w-[700px] mx-auto text-center">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mb-4 leading-tight">
              Pronto a scoprire il
              <br />
              <span className="italic font-light text-foreground-600">mondo</span> di{' '}
              <span className="text-primary-600">Itaobuy sheet?</span>
            </h2>
            <p className="text-foreground-500 mb-8 max-w-[500px] mx-auto">
              Unisciti a migliaia di acquirenti italiani che hanno gi&agrave; scoperto il modo pi&ugrave; intelligente di fare shopping online.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-foreground-900 text-background-50 font-semibold text-base hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Vai a Kaspreadsheet
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
          <div className="max-w-[900px] mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-4">
                Domande <span className="text-primary-600">frequenti</span>
              </h2>
              <p className="text-foreground-500 max-w-[600px] mx-auto">
                Tutto ci&ograve; che devi sapere su Itaobuy Spreadsheet.
              </p>
            </div>

            <div className="space-y-3">
              {faqData.map((faq, i) => (
                <details key={i} className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden">
                  <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                    <span className="text-sm font-semibold text-foreground-800 pr-4">{faq.q}</span>
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-45 transition-transform duration-200">
                      <i className="ri-add-line"></i>
                    </span>
                  </summary>
                  <div className="px-6 pb-4">
                    <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Article CTA */}
        <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
          <div className="max-w-[800px] mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              Approfondisci con la nostra{' '}
              <span className="text-primary-600">Guida Completa</span>
            </h2>
            <p className="text-foreground-500 mb-8 max-w-[550px] mx-auto">
              Leggi la nostra guida dettagliata con consigli, strategie e trucchi per ottenere il massimo da Itaobuy Spreadsheet nel 2026.
            </p>
            <Link
              to="/articolo/guida-completa-itaobuy-spreadsheet"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Leggi la Guida Completa 2026
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}